package it.neckar.lizergy.model.project

import it.neckar.lizergy.model.customer.Customer
import it.neckar.lizergy.model.location.LocationInformation
import it.neckar.open.kotlin.lang.nullIfBlank
import it.neckar.user.UserLoginName
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

/**
 * Base interface for all types of projects
 */
interface ProjectConfiguration : HasUuid, BelongsToCompany {

  val projectId: PhotovoltaicsProjectId

  val projectName: String

  val customer: Customer

  val maintainer: UserLoginName

  val archiveReasons: ArchiveReasons


  override val uuid: Uuid
    get() = projectId.uuid


  /**
   * Project name to be displayed
   * Will take the set name, if is not blank
   *  or construct one from other given information
   *  or take a placeholder if no information is given
   */
  fun displayName(location: LocationInformation?): String {
    // Return manual description if is neither null nor blank
    projectName.nullIfBlank()?.let {
      return it
    }

    customer.companyOrLastName().nullIfBlank()?.let { customerName ->
      return buildString {
        append(customerName)
        location?.address?.city.nullIfBlank()?.let { cityName ->
          //Both name + city
          append(", ")
          append(cityName)
        }
      }
    }

    /**
     * Take placeholder if neither
     *  - manual description nor
     *  - company name nor
     *  - customer name nor
     *  - city
     *  was given
     */
    return "Unbenanntes Projekt"
  }

  fun belongsToMaintainer(userLoginName: UserLoginName?): Boolean {
    return userLoginName == maintainer
  }


  /**
   * An ID for a [ProjectConfiguration]
   */
  @Serializable
  data class PhotovoltaicsProjectId(override val uuid: NativeUuid) : HasUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): PhotovoltaicsProjectId {
        return PhotovoltaicsProjectId(randomUuid4())
      }
    }
  }

}
